import * as React from "react";
import {  Button } from "@mui/material";
import { useTheme } from "@emotion/react";

const Approve = ({ handleApproveSubseller }) => {
  const theme = useTheme();

  return  (
    <Button
      sx={{
        borderRadius: 3,
        py: 1,
        flex: 1,
        bgcolor: theme.palette.darkBlue,
          color: theme.palette.primary.contrastText,
          '&:hover': {backgroundColor: theme.palette.darkBlue},
          boxShadow: "0 0 1rem #ccc",
        mt: 3,
        textTransform: 'none',
        fontSize: '1rem'

      }}
      onClick={handleApproveSubseller}
    >
      Approve Sub-Seller
    </Button>
  );
};

export default Approve;
